/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
export const ConversionType = {
  ELECTRICITY: 'Electricity',
  GAS: 'Gas',
  WATER: 'Water',
  SEWERAGE: 'Sewerage',
  CARBON: 'Carbon',
  ELECTRIC: 'Electric',
  STEAM: 'Steam',
  HOTWATER: 'HotWater',
  CHILLEDWATER: 'ChilledWater'
};

export interface IMeasurementTypeObject {
  measurementType: Array<string>;
  units: IUnits;
}
export interface IunitObject {
  name: string;
  symbol: string;
  minValue: number;
  maxValue: number;
  displayUnit: string;
}

export interface IObjectKeys {
  [key: string]: string;
}

export interface IUnits {
  [key: string]: Array<IunitObject>;
}
